import React from 'react';
import './RecentOrders.css';

const RecentOrders = ({ orders, limit = 3, title = 'Recientes pedidos' }) => {
  if (!orders || orders.length === 0) {
    return null;
  }

  return (
    <div className="recent-orders">
      <h3>{title}</h3>
      <div className="orders-list">
        {orders.slice(0, limit).map(order => (
          <div key={order.id} className="order-card">
            <div className="order-info">
              <div className="order-header">
                <h4>Pedido #{order.id}</h4>
                <span className="order-status-badge">{order.status}</span>
              </div>
              <p className="order-date">
                {new Date(order.timestamp || Date.now()).toLocaleDateString()}
              </p>
              <p className="order-items">
                {order.items?.map(item => item.name).join(', ') || 'No items'}
              </p>
              <p className="order-total">${order.total?.toFixed(2) || '0.00'}</p>
            </div>
            <button className="reorder-btn">
              Reordenar
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentOrders;